import styled from 'styled-components';

const StyledTitle = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 10px;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    line-height: 24px;
    font-size: 20px;
    margin-bottom: 24px;
  }
  ${({ theme }) => theme.newBreakpoint('md')} {
    margin-bottom: 24px;
    line-height: 26px;
    font-size: 20px;
  }
`;

export default StyledTitle;
